
import * as React from 'react';
import { Grid, Select, MenuItem, Link } from '@material-ui/core';
import { AutoCalculationOperatorsForAdmin } from '../../constants/data';
import { Guid } from 'guid-typescript';

export default class VerticalAutoCalculationForAdminLevelComponent extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            iterations: [],
            adminLevelQuestions: [],
            operator: '+',
        }
        this.handleOperator = this.handleOperator.bind(this);
        this.handleAddMoreQuestion = this.handleAddMoreQuestion.bind(this);
        this.handleQuestionChange = this.handleQuestionChange.bind(this);
        this.handleResetVertical = this.handleResetVertical.bind(this);
    }

    componentDidMount() {
        this.setLocalState()
    }
    setLocalState = () => {
        const iterations = []
        const questionId = {}
        for (let index = 1; index <= this.props.question.class_type; index++) {
            iterations.push(index);
            let counters: any = [];
            if (this.props.question.auto_calculation_config.vertical_config) {
                if (this.props.question.auto_calculation_config.vertical_config.set_wise_questions.length >= index) {
                    counters = this.props.question.auto_calculation_config.vertical_config.set_wise_questions[index - 1].question_ids.map((q: any, ind: any) => ind + 1)
                }
                else {
                    counters = undefined;
                }
            }
            const counter = counters === undefined ? [1, 2] : [...counters]
            questionId[`questionId_${index}`] = { counters: counter, questionIds: [] }
        }

        this.setState({ iterations, adminLevelQuestions: this.getQuestionList(), questionId }, () => this.parseObjectToState());
        this.props.onVerticalAddMore('questionId', questionId);
    }

    restorePercentageView = (): void => {
        const questionId = {};
        for (let setIndex = 1; setIndex <= this.state.iterations.length; setIndex++) {
            const stateName = `questionId_${setIndex}`;
            if (this.state.questionId[stateName].counters.length !== 0) {
                for (let questionIdIndex = 1; questionIdIndex <= this.state.questionId[stateName].counters.length; questionIdIndex++) {
                    questionId[stateName] = { counters: [1, 2], questionIds: [] }
                }
            }
            else {
                questionId[stateName] = { counters: [1, 2], questionIds: [] }
            }

        }
        this.setState({ iterations: this.state.iterations, adminLevelQuestions: this.getQuestionList(), questionId },
            () => this.props.onVerticalAddMore('questionId', this.state.questionId));
        this.passCurrentObjectToParent(undefined);
    }

    getQuestionList = () => {
        const questions = [];
        const noOfPages = this.props.allData.moduleQuestion.pages.length;
            for (let i = 0; i < noOfPages; i++) {
            const countCluster = this.props.allData.moduleQuestion.pages[i].question_clusters.length;
            for (let j = 0; j < countCluster; j++) {
                const countQuestion = this.props.allData.moduleQuestion.pages[i].question_clusters[j].questions.length;
                for (let k = 0; k < countQuestion; k++) {
                    if (this.props.allData.moduleQuestion.pages[i].question_clusters[j].questions[k].input_type === 7) {
                        const pageNumber=`Page ${this.props.allData.moduleQuestion.pages[i].page_number}`  
                        const questionNumber=this.props.allData.moduleQuestion.pages[i].question_clusters[j].questions[k].question_number !== '' ? this.props.allData.moduleQuestion.pages[i].question_clusters[j].questions[k].question_number + '. ' : '';                
                        const questionTitle= this.props.allData.moduleQuestion.pages[i].question_clusters[j].questions[k].title.en
                        questions.push({
                            questionId: this.props.allData.moduleQuestion.pages[i].question_clusters[j].questions[k].question_id,
                            title: `${pageNumber} - ${questionNumber} ${questionTitle}`
                        })
                    }
                }
            }
        }

        return questions;
    }

    parseObjectToState = () => {
        const setWiseQuestions = this.props.question.auto_calculation_config.vertical_config && this.props.question.auto_calculation_config.vertical_config.set_wise_questions;
        if (this.props.question.auto_calculation_config !== null && this.props.question.auto_calculation_config.vertical_config !== null) {
            for (let setIndex = 1; setIndex <= setWiseQuestions.length; setIndex++) {
                for (let questionIdIndex = 1; questionIdIndex <= setWiseQuestions[setIndex - 1].question_ids.length; questionIdIndex++) {
                    const name = `questionId_${setIndex}${questionIdIndex}`;
                    this.setState({ [name]: setWiseQuestions[setIndex - 1].question_ids[questionIdIndex - 1] },
                        () => this.props.onVerticalQuestionChange(name, this.state[name]))
                }
            }
        }

        this.setState({
            operator: this.props.question.auto_calculation_config.vertical_config
                ? (this.props.question.auto_calculation_config.vertical_config.operator ? this.props.question.auto_calculation_config.vertical_config.operator : this.state.operator)
                : this.state.operator
        },
            () => this.props.onVerticalOperatorChange(this.state.operator));
    }

    handleOperator = (e: any) => {
        this.setState({ operator: e.target.value },
            () => this.restorePercentageView());
        this.props.onVerticalOperatorChange(e.target.value);
    }

    handleAddMoreQuestion = (setIndex: any, e: any) => {
        const questionName = `questionId_${setIndex}`
        const counters = this.state.questionId[questionName].counters;

        const setWiseCounter = this.state.questionId[questionName] ? [...this.state.questionId[questionName].counters, this.state.questionId[questionName].counters.length + 1] : counters;

        const setWiseQuestionIds = this.props.question.auto_calculation_config.vertical_config ?
            this.props.question.auto_calculation_config.vertical_config.set_wise_questions[setIndex - 1].question_ids.map((a: any) => a) :
            [];

        const questionId = { ...this.state.questionId, [questionName]: { counters: setWiseCounter, questionids: [...setWiseQuestionIds] } }

        this.setState({ questionId }, () => this.props.onVerticalAddMore('questionId', this.state.questionId));
    }

    handleQuestionChange = (setIndex: any, questionIndex: any, e: any) => {
        const name = `questionId_${setIndex}${questionIndex}`;
        this.setState({ [name]: e.target.value },
            () => this.passCurrentObjectToParent(name));
    }
    passCurrentObjectToParent = (name: any) => {
        if (name) {
            this.props.onVerticalQuestionChange(name, this.state[name]);
        }
        for (let index = 1; index <= this.props.question.class_type; index++) {
            const stateName = `questionId_${index}`;
            for (let questionIdIndex = 1; questionIdIndex <= this.state.questionId[stateName].counters.length; questionIdIndex++) {
                const qName = `questionId_${index}${questionIdIndex}`;
                this.props.onVerticalQuestionChange(qName, this.state[qName]);
            }
        }
    }
    resetState = () => {
        const iterations = [];
        const questionId = {};
        for (let index = 1; index <= this.props.question.class_type; index++) {
            iterations.push(index);
            const counters: any = [];
            questionId[`questionId_${index}`] = { counters, questionIds: [] }
        }

        this.setState({ iterations, adminLevelQuestions: this.getQuestionList(), questionId, operator: '+'});
    }

    handleResetVertical = () => {
        const newState: any = this.state;
        for (let index = 1; index <= this.props.question.class_type; index++) {
            const stateName = `questionId_${index}`;
            for (let questionIdIndex = 1; questionIdIndex <= this.state.questionId[stateName].counters.length; questionIdIndex++) {
                const qName = `questionId_${index}${questionIdIndex}`;
                delete newState[qName];
            }
        }
        this.resetState();
    }
    render() {
        return (
            <>
                <Grid container={true} spacing={24}>
                    <Grid item={true} xs={3}>
                        <label className="dialogLabel">Select Operator</label>
                    </Grid>
                    <Grid item={true} xs={8}>
                        <Select
                            fullWidth={true}
                            value={this.state.operator}
                            onChange={this.handleOperator}
                        >
                            
                            {
                                
                                AutoCalculationOperatorsForAdmin.map((operator: any) => {
                                    return (
                                        <MenuItem
                                            key={operator.value}
                                            value={operator.value}
                                        >
                                            {operator.text}
                                        </MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </Grid>
                </Grid>
                {
                    this.state.adminLevelQuestions && this.state.adminLevelQuestions.length > 0 ? (
                        this.state.iterations.map((iterator: any) => {
                            const name = `questionId_${iterator}`
                            return (
                                <div key={'verticalConfig_' + iterator} className="dialogBorderBox">
                                    <span><b><u>{'Set ' + iterator}</u></b></span>
                                    <Grid container={true} spacing={24}>
                                        <Grid item={true} xs={3}>
                                            <label className="dialogLabel"> Select Question </label>
                                        </Grid>
                                        <Grid item={true} xs={8}>
                                            <Grid container={true} spacing={24}>
                                                <Grid item={true} xs={12}>
                                                    {
                                                        this.state.questionId && this.state.questionId[name] && this.state.questionId[name].counters.map((setWiseCounter: any) => {
                                                            const questionName = `questionId_${iterator}${setWiseCounter}`
                                                            return (
                                                                <Select
                                                                    key={Guid.create().toString()}
                                                                    name={questionName}
                                                                    fullWidth={true}
                                                                    value={this.state[questionName] ? this.state[questionName] : ''}
                                                                    onChange={this.handleQuestionChange.bind(this, iterator, setWiseCounter)}
                                                                >
                                                                    {
                                                                        this.state.adminLevelQuestions && this.state.adminLevelQuestions.map((question: any) => {
                                                                            return (
                                                                                <MenuItem key={questionName} value={question.questionId}>
                                                                                    {question.title}
                                                                                </MenuItem>
                                                                            )
                                                                        })
                                                                    }
                                                                </Select>
                                                            )
                                                        })
                                                    }
                                                    {
                                                        this.state.operator === '+' ? (
                                                            <Link href="javascript:void(0)" color='primary' onClick={this.handleAddMoreQuestion.bind(this, iterator)} >+ Add more</Link>
                                                        ) : ''
                                                    }
                                                    {
                                                        this.state.operator === '-' ? (
                                                            <Link href="javascript:void(0)" color='primary' onClick={this.handleAddMoreQuestion.bind(this, iterator)} >+ Add more</Link>
                                                        ) : ''
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>


                                </div>
                            )
                        })
                    ) : <div className="errorMessage">There are no Admin level type questions found previous to this question.</div>
                }
                <Link href="javascript:void(0)" onClick={this.handleResetVertical}>Reset All</Link>
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/questions/VerticalAutoCalculationForAdminLevelComponent.tsx